export enum QuranTutorsRouteName {
    Registration = 'quran-tutors-registration',
    Batch = 'quran-tutors-batch',
    Verification = 'quran-tutors-verification',
    InstructorRegistration = 'quran-tutors-instructor-registration',
    InstructorVerification = 'quran-tutors-instructor-verification',
    InstructorQuranMethod = 'quran-tutors-instructor-quran-method',
    TeachingVideos = 'quran-tutors-teaching-videos',
    ManualPresence = 'quran-tutors-manual-presence',
    List = 'quran-tutors-list',
    TutorDetail = 'quran-tutors-detail-list',
    TutorDetailProfile = 'quran-tutors-detail-profile',
    ValidateActivity = 'quran-tutors-validate-activity',
    ValidateActivityVerification = 'quran-tutors-validate-activity-verification',
    Incentive = 'quran-tutors-incentive',
    Disbursement = 'quran-tutors-disbursement',
    Report = 'quran-tutors-report',
    ReportDetail = 'quran-tutors-report-detail'
}
